type Sink = Pick<Console, 'debug' | 'info' | 'warn' | 'error'>
type BeaconNav = Pick<Navigator, 'sendBeacon'>

export function createLogger(isProd = import.meta.env?.PROD, sink: Sink = console, nav?: Partial<BeaconNav>) {
  const log = (level: keyof Sink, args: unknown[]) => {
    if (isProd && (level === 'debug' || level === 'info')) return
    sink[level](...args)
  }
  return {
    debug: (...args: unknown[]) => log('debug', args),
    info: (...args: unknown[]) => log('info', args),
    warn: (...args: unknown[]) => log('warn', args),
    error: (...args: unknown[]) => log('error', args),
    reportClientError: (error: Error, info?: { componentStack?: string }) => {
      const payload = JSON.stringify({
        message: error.message,
        stack: error.stack,
        component_stack: info?.componentStack ?? '',
        path: typeof location === 'undefined' ? '' : location.pathname,
        user_agent: typeof navigator === 'undefined' ? '' : navigator.userAgent,
      })
      const beaconNav = nav ?? (typeof navigator === 'undefined' ? undefined : navigator)
      beaconNav?.sendBeacon?.('/v1/client-errors', payload)
    },
  }
}

export const logger = createLogger()
